module.exports = __webpack_public_path__ + "static/media/sale orders.5240a3ad.svg";